// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

import type { CapabilityImage } from "@dsbunny/capdb-schema";
import { kImageCanvases } from "./canvases.js";

export async function imageDecodingInfo(): Promise<Array<CapabilityImage>> {
	if(!('ImageDecoder' in window)
		|| window.ImageDecoder === null)
	{
		throw new Error('ImageDecoder API not available');
	}
	const capabilities: Array<CapabilityImage> = [];
	for(const canvas of kImageCanvases) {
		// FIXME: `error TS2339: Property 'isTypeSupported' does not exist on type '{}'.`
		const result = await (window.ImageDecoder as any).isTypeSupported(canvas.mimeType);
		// Explicitly test a range of image sizes for compatibility.
		// Start from largest to smallest, as the largest is most likely
		// to fail.  On success, the smaller sizes can be assumed to be
		// supported.

		// `HTMLImageElement.decode()` is not stable and can throw random errors:
		// `EncodingError: The source image cannot be decoded.`
		let is_supported = false;
		for(const configuration of canvas.configurations) {
			if(result && !is_supported) {
				const img = new Image();
				try {
					await new Promise((resolve, reject) => {
						img.onload = resolve;
						img.onerror = reject;
						img.setAttribute('src', `fixtures/${configuration.test.href}`);
						//img.setAttribute('src', `./content/external/usb/2/dsb/${configuration.test.href}`);
					});
					is_supported = true;
				} catch(err: unknown) {
					console.warn(`${canvas.mimeType} ${configuration.width}x${configuration.height}: ${err}`);
				} finally {
					img.removeAttribute('src');
				}
			}
			const capability: CapabilityImage = {
				mime_type: 'image',
				mime_subtype: canvas.mimeType.split('/')[1],
				is_supported,
				is_smooth: false,
				is_power_efficient: true,
				width: configuration.width,
				height: configuration.height,
			};
			capabilities.push(capability);
		}
	}
	return capabilities;
}
